export const LOGIN_MUTATION = `
  mutation Login($input: LoginRequest!) {
    login(input: $input) {
      id
      firstName
      lastName
      emailAddress
      companyId
      role
      accessToken
      refreshToken
    }
  }
`;

export const LOGOUT_MUTATION = `
  mutation Logout($input: LogoutRequest!) {
    logout(input: $input) {
      success
      message
    }
  }
`;

export const REFRESH_TOKEN_MUTATION = `
  mutation RefreshToken($input: RefreshTokenRequest!) {
    refreshToken(input: $input) {
      accessToken
      refreshToken
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = `
  mutation ForgotPassword($input: ForgotPasswordRequest!) {
    forgotPassword(input: $input) {
      success
      message
    }
  }
`;

export const RESET_PASSWORD_MUTATION = `
  mutation ResetPassword($input: ResetPasswordRequest!) {
    resetPassword(input: $input) {
      success
      message
    }
  }
`;

